module.exports = __webpack_public_path__ + "media/assets/images/wallpapers/working_man-ef5331db806120b02c6172be05e53af4.jpg";